import Card from "src/components/Card";

interface FormGridProps {
	children?: any;
}

const FormGrid = ({ children }: FormGridProps) => {
	return (
		<div
			className={`md:grid-cols-[300px,1fr] lg:grid-cols-[400px,1fr] grid gap-8`}
		>
			{children}
		</div>
	);
};

interface HeaderProps {
	title?: string;
	children?: any;
}

const Header = ({ title, children }: HeaderProps) => {
	return (
		<div className="md:p-8 flex flex-col gap-4 md:sticky md:top-24 bg-white">
			<h2 className="text-[22px] md:text-[24px] lg:text-[30px]">
				{title}
			</h2>
			{children && <div className="">{children}</div>}
		</div>
	);
};

interface CardProps {
	children?: any;
	className?: string;
}

const WrapperCard = ({ children, className }: CardProps) => {
	return (
		<div className={`max-w-[640px] mb-8 ${className || ""}`}>
			<Card className="">{children}</Card>
		</div>
	);
};

FormGrid.Header = Header;
FormGrid.Card = WrapperCard;

export default FormGrid;
